import { render, staticRenderFns } from "./MenuProducts.vue?vue&type=template&id=686d57e6&scoped=true&"
import script from "./MenuProducts.vue?vue&type=script&lang=js&"
export * from "./MenuProducts.vue?vue&type=script&lang=js&"
import style0 from "./MenuProducts.vue?vue&type=style&index=0&id=686d57e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686d57e6",
  null
  
)

export default component.exports